// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import ExclamationCircleFilledSvg from "@ant-design/icons-svg/lib/asn/ExclamationCircleFilled";
import AntdIcon from "../components/AntdIcon";
const ExclamationCircleFilled = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: ExclamationCircleFilledSvg
    });
if (process.env.NODE_ENV !== "production") {
    ExclamationCircleFilled.displayName = "ExclamationCircleFilled";
}
export default /*#__PURE__*/ React.forwardRef(ExclamationCircleFilled);
